<template>
    <div class="color-picker">
        <div
            v-for="variant in variants"
            :class="{ selected: variant.id == (product.id || selected) }"
            :key="`color-${variant.id}`"
            :style="{ 'background-color': variant.colors_code }"
            :title="variant.colors"
            class="color-circle"
            @click="updateAccessories(variant)"
        />
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "AccesoryColorPicker",
    props: {
        product: {
            type: Object,
            required: true
        },
        variants: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selected: null
        }
    },
    computed: {
        qty() {
            return this.product.quantity || 1;
        }
    },
    methods: {
        ...mapActions({
            updatePart: "StarterPc/updatePart"
        }),
        updateAccessories(variant) {
            if (this.product.id) {
                this.updatePart({ part: variant, qty: this.qty });
            } else {
                this.selected = variant.id;
                this.$emit("select-variant", variant);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.color-picker {
    display: flex;
    justify-content: center;
    padding: 15px 0;

    .color-circle {
        width: 32px;
        height: 32px;
        border: 3px solid $white;
        box-shadow: 0 0 0 1px #dadde0;
        margin-left: 6px;
        border-radius: 100%;
        cursor: pointer;

        &:first-child {
            margin-left: 0;
        }

        &.selected {
            box-shadow: 0 0 0 1px $purple;
        }
    }
}
</style>
